import * as React from 'react';

import { ProfileNotificationsProvider } from 'bundles/account-profile/components//recruiting-profile-viewer/ProfileNotificationProvider';
import { InviteToApplyProvider } from 'bundles/account-profile/components/recruiting-profile-viewer/InviteToApplyProvider';
import OccupationRolesProvider from 'bundles/account-profile/components/recruiting-profile-viewer/OccupationRolesProvider';
import ProfileContextProvider from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import RecruitingProfileViewer from 'bundles/account-profile/components/recruiting-profile-viewer/RecruitingProfileViewer';
import { LearnerProfileQueryProvider } from 'bundles/account-profile/components/recruiting-profile-viewer/queries/providers/LearnerProfileQueryProvider';

type PropsFromCaller = {
  externalId?: string;
  profileSlug?: string;
  isEditMode: boolean;
};

const RecruitingProfileViewerWithProviders = ({ externalId, profileSlug, isEditMode }: PropsFromCaller) => {
  return (
    <LearnerProfileQueryProvider externalId={externalId} profileSlug={profileSlug}>
      {({ learnerProfile, isProfileLoading, refetchLearnerProfileMe, refetchLearnerProfileExternalId, error }) => (
        <ProfileContextProvider
          isEditMode={isEditMode}
          // @ts-expect-error - reconcile missing displaySettings types in future PR (to keep the size of this one smaller)
          learnerProfile={learnerProfile}
          isProfileLoading={isProfileLoading}
          refetchLearnerProfileMe={refetchLearnerProfileMe}
          refetchLearnerProfileExternalId={refetchLearnerProfileExternalId}
          error={error}
        >
          <OccupationRolesProvider>
            <ProfileNotificationsProvider>
              <InviteToApplyProvider>
                <RecruitingProfileViewer />
              </InviteToApplyProvider>
            </ProfileNotificationsProvider>
          </OccupationRolesProvider>
        </ProfileContextProvider>
      )}
    </LearnerProfileQueryProvider>
  );
};

export default RecruitingProfileViewerWithProviders;
